<template>
  <el-form ref="elFormRef" :label-width="80" :model="formData" :rules="formRules">
    <el-form-item label="标记分级" prop="_标记分级">
      <el-select v-model="formData._标记分级" placeholder="请选择">
        <el-option
          v-for="item in options"
          :key="item"
          :disabled="item.value !== 'BLACK'"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script setup>
  import { ref, reactive, defineExpose, defineEmits, toRaw, getCurrentInstance } from 'vue'
  import { addBlackList } from '@/api/jbh'

  const { proxy } = getCurrentInstance()

  const elFormRef = ref()

  const props = defineProps({
    uid: {
      type: [String, Number],
      required: true,
    },
    _标记分级: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
  })

  const emit = defineEmits(['success', 'close'])

  const formData = reactive({
    _标记分级: props._标记分级,
  })

  const formRules = {
    _标记分级: [
      {
        required: true,
        message: '请选择标记分级',
      },
    ],
  }

  function submit() {
    elFormRef.value.validate((valid) => {
      if (!valid) return
      // const params = toRaw(formData)
      // console.log('params', params)
      addBlackList(props.uid).then(() => {
        proxy.$baseMessage(`处理成功！`, 'success', 'vab-hey-message-success')
        emit('success')
      })
    })
  }

  defineExpose({
    submit,
  })
</script>

<style lang="scss" scoped></style>
